jQuery_T4NT(document).ready(function($) {

    var allPagesLoaded = false; // Flag to track if all pages have been loaded

    $(window).scroll(function() {
        var paginationWrapper = $('.t4s-pagination-wrapper');
        var loadPreviewButton = $('.loadpreview');
        
        // Check if URL contains ?page=1
        if (window.location.href.indexOf('?page=1') !== -1) {
            return; // Stop further execution if ?page=1 is in the URL
        }

        if (!allPagesLoaded && paginationWrapper.length && loadPreviewButton.length) {
            if (isInViewport(paginationWrapper)) {
                loadPreviewButton.click();
            }
        }
    });

    // Function to check if an element is in the viewport
    function isInViewport(elem) {
        var bounding = elem[0].getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

  for (let i = 0; i <= 9; i++) {
  $(`.JAVA-${i}`).click(function() {
    // Hide all elements with class starting with "PYTHON-"
    for (let j = 0; j <= 9; j++) {
      if (j !== i) {
        $(`.PYTHON-${j}`).css("display", "none");
      }
    }
    // Remove "is--opend" class from all elements with class starting with "JAVA-"
    for (let k = 0; k <= 9; k++) {
      if (k !== i) {
        $(`.JAVA-${k}`).removeClass("is--opend");
      }
    }
  });
}


    // Function to indicate that all pages have been loaded
    function setAllPagesLoaded() {
        allPagesLoaded = true;
    }

    // Call setAllPagesLoaded() function when all pages are loaded
    // Replace the selector '#page' with the appropriate selector for your pagination elements
    $(document).on('allPagesLoadedEvent', setAllPagesLoaded);
  
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});
